module.exports = __webpack_public_path__ + "static/media/gts21.f9138937.png";